var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87.884,
    height: 155.092,
    viewBox: "0 0 87.884 155.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31799",
    "data-name": "Rectangle 31799",
    width: 87.884,
    height: 155.092,
    fill: "#56aa1c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pricing_icon",
    "data-name": "Pricing icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40511",
    "data-name": "Path 40511",
    d: "M80.712,0H7.172A7.18,7.18,0,0,0,0,7.172V147.921a7.18,7.18,0,0,0,7.172,7.172h73.54a7.18,7.18,0,0,0,7.172-7.172V7.172A7.18,7.18,0,0,0,80.712,0M27.458,8.109a2.724,2.724,0,0,1,2.721-2.721H60.506a2.724,2.724,0,0,1,2.721,2.721v.208a2.725,2.725,0,0,1-2.721,2.721H30.179a2.725,2.725,0,0,1-2.721-2.721ZM45.343,146.644a6.4,6.4,0,1,1,6.4-6.4,6.409,6.409,0,0,1-6.4,6.4m37.883-19.49a3.761,3.761,0,0,1-3.757,3.757H11.217a3.761,3.761,0,0,1-3.757-3.757V19.009a3.762,3.762,0,0,1,3.757-3.757H79.469a3.762,3.762,0,0,1,3.757,3.757Z",
    transform: "translate(0 0)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40512",
    "data-name": "Path 40512",
    d: "M56.2,60.249c-.5,3.008-2.173,4.18-6.1,6.1S34.6,67.361,22.762,55.569C10.97,43.728,10.059,32.154,11.976,28.235s3.093-5.6,6.1-6.1c2.216-.369,3.3-1.146,4.315-.128a6.027,6.027,0,0,1,1.117,1.884,77.515,77.515,0,0,0,4.015,7.69s1.672,1.84-1,3.677a13.975,13.975,0,0,0-3.426,2.926c-.753.753-1.178,1.188.333,4.347a25.829,25.829,0,0,0,4.545,6.733c.127.126.257.25.387.372l.336.336c.12.13.243.257.369.384A25.813,25.813,0,0,0,35.8,54.9c3.157,1.512,3.594,1.087,4.347.335a14.036,14.036,0,0,0,2.925-3.427c1.839-2.675,3.679-1,3.679-1a77.185,77.185,0,0,0,7.69,4.011,6.049,6.049,0,0,1,1.884,1.116c1.018,1.018.24,2.1-.128,4.317",
    transform: "translate(11.331 22.968)",
    fill: "#56aa1c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingicon);
export default __webpack_public_path__ + "static/media/Pricing icon.ebadd60c4b3817c3d4589e7afffdcf4d.svg";
export { ForwardRef as ReactComponent };